// All API endpoints are managed here
export const ENDPOINTS = {
  // Authentication
  login: "/auth/m/login",
  customerRegister: "/auth/c/register",
  verifyOtp: "/auth/verify-otp",
  resendOtp: "/auth/resend-otp",
  //services
  getAllServiceCategories: "/service-categories",
  // category
  getCategoryById: (id) => `/service-categories/${id}`,
  getAttributeByEntity: (id, entity) =>
    `/service-categories/${id}/attributes/${entity}`,
  getAddonsByCategory: (categoryId) => `/categories/${categoryId}/addons`,
  // Subscriptions
  getSubscriptionPlans: (categoryId) => `/categories/${categoryId}/subscription-plans`,
  purchaseSubscription: `/user/subscriptions`,
  // service provider
  getServiceProviders: (categoryId) =>
    `/service-categories/${categoryId}/providers`,
  getProviderById: (id) => `/providers/${id}`,
  getProviderSlots: (providerId) => `/providers/${providerId}/slots`,
  toggleProviderLikeStatus: (providerId) => `/providers/${providerId}/like`,
  getLikedStatusForProvider: (providerId) => `/providers/${providerId}/like`,
  blockSlotByProvider: "/slots/block-slot",
  getBlockSlotsByProvider: "/slots/blocked-slots",
  unBlockSlotsByProvider: "/slots/unblock-slot",
  bulkBlockSlotByProvider: "/slots/bulk-block-slot",
  bulkUnBlockSlotsByProvider: "/slots/bulk-unblock-slot",
  recurringBlockSlotByProvider: "/slots/recurring-block-slot",
  // services
  getAllServices: "/services",
  getProviderServices: (providerId) => `/providers/${providerId}/services`,
  getServiceById: (serviceId) => `/providers/services/${serviceId}`,
  // bookings
  createBooking: `/bookings`,
  getAllProviderBookings: "/bookings",
  getBookingById: (bookingId) => `/bookings/${bookingId}`,
  cancelBookingById: (bookingId) => `/bookings/${bookingId}/cancel`,
  getMyBookings: "/bookings/me",
  // customer
  getCurrUser: "/user/profile",
  // payment
  verifyOrder: "/payment/verify",
  // banner
  getBannerAds: "/banner-ads",
  // wallet
  getWallet: "/wallet",
  // discount
  getApplicableDiscount: "/discounts/applicable",
  validateDiscountCode: "/bookings/validate-discount",
  applyDiscountCode: (id) => `/bookings/${id}/apply-discount`,
  removeDiscountCode: (id) => `/bookings/${id}/remove-discount`,

  // offline vouchers
  getOfflineVouchers: "/user/my-offline-vouchers",

  // Booking Steps
  getBookingSteps: (categoryId, serviceId) =>
    serviceId
      ? `/service-categories/${categoryId}/services/${serviceId}/booking-steps`
      : `/service-categories/${categoryId}/booking-steps`,
  uploadMedia: "/media/upload",

  // Community
  getFollowers: (userId) => `/community/followers/${userId}`,
  getFollowing: (userId) => `/community/following/${userId}`,
  followUser: `/community/follow`,
  unfollowUser: `/community/unfollow`,

  getPostsFeed: `/community/posts`,
  createNewPost: `/community/posts`,
  getMyPosts: `/community/posts/my`,
  getSinglePost: (postId) => `/community/posts/${postId}`,
  updatePost: (postId) => `/community/posts/${postId}`,
  deletePost: (postId) => `/community/posts/${postId}`,
  likeUnlikePost: (postId) => `/community/posts/${postId}/like`,
  getPostLikes: (postId) => `/community/posts/${postId}/likes`,
  getUserPosts: (userId) => `/community/posts/user/${userId}`,
  getDraftPosts: `/community/posts/drafts`,
  publishDraftPost: (postId) => `/community/posts/${postId}/publish`,

  getPostComments: (postId) => `/community/posts/${postId}/comments`,
  createPostComment: (postId) => `/community/posts/${postId}/comments`,
  deletePostComment: (postId) => `/community/comments/${postId}`,

  adminDeletePost: (postId) => `/admin/community/posts/${postId}`,
  adminDeleteComment: (commentId) => `/admin/community/comments/${commentId}`,
  adminGetAllPosts: `/admin/community/posts`,


  // staff
  getStaff: "/staff",
  // wallet
  getUserWallet: "/user/kcoin/wallet",
  getWalletSummaryCategoryBreakdown: "/user/kcoin/wallet/summary",
  calculateRedemptionPreview: "/user/kcoin/calculate-redemption",
  getKcoinTransactionHistory: "/user/kcoin/transactions",
  getKCoinTransactionDetail: (id) => `/user/kcoin/transactions/${id}`,
  getKcoinBatches: "/user/kcoin/batches",
  getKcoinBatchDetail: (id) => `/user/kcoin/batches/${id}`,
  // referral code
  getReferralStats: "/user/referral/stats/",
  getReferralHistory: "/user/referral/history",
  getReferralCode: "/user/referral/code",
  updateReferralCode: "/user/referral/code",
  // User Vehicles
  addVehicle: "/user/vehicles",
  updateVehicle: (id) => `/user/vehicles/${id}`,
  deleteVehicle: (id) => `/user/vehicles/${id}`,
  setDefaultVehicle: (id) => `/user/vehicles/${id}/set-default`,
  getUserVehicles: "/user/vehicles",
  getDefaultVehicle: "/user/vehicles/default",
  // Vehicle Selection
  getVehicleTypes: "/vehicles/types",
  getVehicleBrands: "/vehicles/brands",
  getVehicleModels: (brandId) => `/vehicles/brands/${brandId}/models`,
  // Addresses
  getAllAddresses: "/addresses",
  getAddressById: (id) => `/addresses/${id}`,
  createAddress: "/addresses",
  updateAddress: (id) => `/addresses/${id}`,
  deleteAddress: (id) => `/addresses/${id}`,
  hostGame: "games",
  discoverGames: "games",
  myGames: "games/my-games",
  joinGame: (id) => `games/${id}/join`,
  leaveGame: (id) => `games/${id}/leave`,
  cancelGame: (id) => `games/${id}/cancel`,
};
